import { monthLabel } from '../lib/incident-helpers';
import type { IncidentsResponse } from '../lib/incidents-api';
import { IncidentRow } from './IncidentRow';

interface Props {
  data: IncidentsResponse | undefined;
  loading: boolean;
  error: Error | null;
  onSelect: (id: number) => void;
}

export function IncidentsList({ data, loading, error, onSelect }: Props) {
  return (
    <section>
      <div className="mb-3.5 mt-11 flex items-baseline justify-between">
        <h2 className="m-0 text-[12px] font-semibold uppercase tracking-[.08em] text-ink-3">
          Past Incidents
        </h2>
        {data ? (
          <span className="text-[12px] text-ink-3 [font-feature-settings:'tnum']">
            Last {data.days} days
          </span>
        ) : null}
      </div>

      {loading ? (
        <div className="py-3.5 text-[13px] text-ink-3">Loading…</div>
      ) : error ? (
        <div className="py-3.5 text-[13px] text-down-fg">
          Failed to load incidents.
        </div>
      ) : !data || data.incidents.length === 0 ? (
        <div className="py-3.5 text-[13px] text-ink-3">
          No incidents reported.
        </div>
      ) : (
        <div className="space-y-6">
          {data.groupedByMonth.map((group) => (
            <div key={group.month}>
              <div className="mb-2 text-[11px] font-medium uppercase tracking-wider text-ink-3">
                {monthLabel(group.month)}
              </div>
              <div className="space-y-2">
                {group.incidents.map((incident) => (
                  <IncidentRow
                    key={incident.id}
                    incident={incident}
                    onClick={onSelect}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
